import { Appointment } from '../types';
import { validateTenantId } from './paths';

export const assertAppointmentTenant = (
  tenantIdInput: string,
  appointment: Pick<Appointment, 'tenantId'>
): void => {
  const tenantId = validateTenantId(tenantIdInput);
  if (appointment.tenantId !== undefined && appointment.tenantId !== tenantId) {
    throw new Error('Appointment tenant does not match the active tenant.');
  }
};
